/**
 * 주문 결제 처리 관련 함수
 * 기존 order.ts에서 분리
 */

import { supabase } from '@/lib/supabase';

/**
 * 결제 처리
 */
export async function processPayment(
  orderId: string,
  paymentData: {
    transaction_id: string;
    amount: number;
    gateway_response?: any;
  }
): Promise<{ success: boolean; error?: string }> {
  try {
    // Update payment status
    const { error: paymentError } = await supabase
      .from('payments')
      .update({
        status: 'completed',
        transaction_id: paymentData.transaction_id,
        paid_at: new Date().toISOString(),
        metadata: paymentData.gateway_response
      })
      .eq('order_id', orderId);

    if (paymentError) {
      return { success: false, error: '결제 정보 업데이트에 실패했습니다.' };
    }

    // Update order payment status
    const { error: orderError } = await supabase
      .from('orders')
      .update({ payment_status: 'PAID' })
      .eq('id', orderId);

    if (orderError) {
      return { success: false, error: '주문 상태 업데이트에 실패했습니다.' };
    }

    return { success: true };
  } catch (error) {
    console.error('Error processing payment:', error);
    return { success: false, error: '결제 처리 중 오류가 발생했습니다.' };
  }
}